import axios from 'axios';

export function rejectServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/reject`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

export function approveServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/approve`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  serviceProviders: any[]
 * }} data
 */
export function updateServiceProviders(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/updateFieldServiceProviders`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            serviceProviders: data.serviceProviders,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
export function approveNewServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/approveNew`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
export function rejectNewServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/rejectNew`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
export function approveRemoveServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/approveRemove`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

/**
 * 
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
export function rejectRemoveServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/rejectRemove`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch((error) => {
            throw error.response.data.errors[0].messages[0];
        });
}

export function getServiceProvidersHistory(portId, data) {
    return axios({
        method: 'POST',
        url: `/api/v2/ports/${portId}/service-providers/history`,
        data,
        withCredentials: true,
    })
        .then((response) => {
            response.data.total = response.headers['x-total-count'];
            return response.data;
        })
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/regions/serviceProvider.js